import closeFill from '@iconify/icons-eva/close-fill';
import { Icon } from '@iconify/react';
import {
    Avatar,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    makeStyles,
    Stack,
    Typography,
} from '@mui/material';
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack';
import React, { forwardRef, useCallback } from 'react';

import { IconButtonAnimate } from 'components/animate';

interface ReportCompleteProps extends CustomContentProps {
    title: string;
    image?: string;
}

const NotificationSnackbar = forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
    const {
        // You have access to notistack props and options 👇🏼
        id,
        message,
        // as well as your own custom props 👇🏼
        title,
        image,
        ...other
    } = props;

    const { closeSnackbar } = useSnackbar();

    const handleDismiss = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);

    return (
        <SnackbarContent ref={ref} role='alert' {...other}>
            <Card sx={{ width: '100%' }}>
                {image && <CardMedia sx={{ height: 120 }} image={image} title={title} />}
                <CardContent sx={{ p: 2 }}>
                    <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
                        <Typography variant='h6'>{title}</Typography>
                        <IconButtonAnimate onClick={handleDismiss}>
                            <Icon icon={closeFill} />
                        </IconButtonAnimate>
                    </Stack>
                    <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
                        {message}
                    </Typography>
                </CardContent>
            </Card>
        </SnackbarContent>
    );
});

NotificationSnackbar.displayName = 'NotificationSnackbar';

export default NotificationSnackbar;
